module.exports = __webpack_public_path__ + "img/java.e70e2773.svg";